import { createContext } from 'react'

const DEFAULT = {
  getTableValues: () => null,
  setTableValues: () => null,
}

export const TableValuesContext = createContext(DEFAULT)
